<dx-button class="send" icon="{{ moreFilters ? 'chevronup' : 'chevrondown' }}" width="100%"
  text="{{ (moreFilters ? lessFiltersLabel : moreFiltersLabel) | transloco }}" (onClick)="toggle();">
</dx-button>